module.exports = __webpack_public_path__ + "img/uboot-stencil.dcc1b01b.svg";